import React from 'react';
import SettingsIcon from '@mui/icons-material/Settings'; // Matches your existing icon set
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const Maintenance = ({downtime = "TBH"}) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-slate-50 flex items-center justify-center w-screen h-screen">
      {/* Background decoration for a professional feel */}
      <div className="absolute top-0 left-0 w-full h-1 bg-blue-600"></div>

      <div className="flex flex-col items-center justify-center p-10 text-center bg-white border border-slate-200 rounded-2xl shadow-xl max-w-lg mx-4">

        {/* Status Badge */}
        <div className="mb-8 inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-wider border border-blue-100">
          <span className="relative flex h-2 w-2 mr-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
          </span>
          System Update
        </div>

        {/* Main Visual */}
        <div className="mb-8 relative">
          <div className="absolute inset-0 bg-blue-100 rounded-full blur-3xl opacity-20 transform scale-150"></div>
          <img
            src="/images/maintenance_mode.svg"
            alt="Maintenance"
            className="relative h-56 w-auto max-w-full object-contain transition-transform duration-700 hover:scale-105"
          />
        </div>

        {/* Text Content */}
        <div className="space-y-3">
          <h1 className="text-2xl font-extrabold text-slate-800 tracking-tight">
            Module Under Maintenance
          </h1>
          <p className="text-slate-500 leading-relaxed max-w-sm mx-auto">
            We are currently enhancing this module to provide you with a better experience.
            The features will be back online shortly.
          </p>
        </div>

        {/* Footer Action */}
        <div className="mt-10 pt-8 border-t border-slate-100 w-full flex flex-col items-center gap-4">
          <button
            onClick={() => window.location.pathname = "/"}
            className="flex items-center gap-2 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-all duration-200 shadow-md shadow-blue-100 active:transform active:scale-95"
          >
            <ArrowBackIcon sx={{ fontSize: 18 }} />
            Back to Dashboard
          </button>

          <div className="flex items-center gap-1.5 text-slate-400 text-xs mt-2">
            <SettingsIcon sx={{ fontSize: 14 }} className="animate-spin-slow" />
            <span>Expected downtime: {downtime}</span>
          </div>
        </div>
      </div>

      {/* Tailwind helper class needed for the slow spin */}
      <style dangerouslySetInnerHTML={{
        __html: `
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
      `}} />
    </div>
  );
};